import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface SpocManagementItemsPerPageDTO {
  items: number;
}

export class SpocManagementItemsPerPage {
  readonly isSpocManagementItemsPerPageSpocManagementItemsPerPage: boolean = true;

  readonly items: number;

  static readonly constraints = {
    "items": {
      "minValue": 1,
    }
  }

  constructor(
  items: number
  ) {
    SpocManagementItemsPerPage.validateItems(items);
    this.items = items;
  }

  static fromDTO(dto: SpocManagementItemsPerPageDTO): SpocManagementItemsPerPage {
    const items = getInt32(dto, "items", InvalidSpocManagementItemsPerPageItemsError);
    return new SpocManagementItemsPerPage(
      items
    );
  }

  toDTO(): SpocManagementItemsPerPageDTO {
    const dto: SpocManagementItemsPerPageDTO = {
        items: this.items
    };
    return dto;
  }
  private static validateItems = (items: number): void => {
    if(items < 1) {
      throw new InvalidSpocManagementItemsPerPageItemsMinValueError(
        1,
        `Attribute items has value ${items}. Min value is 1.`
      );
    }
  }
  
}

SpocManagementItemsPerPage.prototype.toString = function toString(): string {
  return `SpocManagementItemsPerPage(items='${this.items}')`;
};

export class InvalidSpocManagementItemsPerPageError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocManagementItemsPerPageError";
  }
}
export class InvalidSpocManagementItemsPerPageItemsError extends InvalidSpocManagementItemsPerPageError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocManagementItemsPerPageItemsError";
  }
}

export class InvalidSpocManagementItemsPerPageItemsMinValueError extends InvalidSpocManagementItemsPerPageItemsError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSpocManagementItemsPerPageItemsMinValueError";
  }
}
